import { DIALOG_TYPE } from "@/constants/constants";
export default {
  methods: {
    showMessage(message, onOk = null, options = null) {
      this.$emit(
        "showModal",
        message,
        DIALOG_TYPE.MESSAGE,
        onOk,
        null,
        options
      );
    },

    showConfirm(message, onOk = null, onCancel = null, options = null) {
      this.$emit(
        "showModal",
        message,
        DIALOG_TYPE.CONFIRM,
        onOk,
        onCancel,
        options
      );
    },
  },
};
